import { z } from "zod";

export const requiredString = z.string({ error: "is required" }).min(1, "must not be empty");

export const positiveInt = z
  .string({ error: "is required" })
  .regex(/^[1-9]\d*$/, "must be a positive integer")
  .transform(Number);

export const positiveNumber = z
  .string({ error: "is required" })
  .regex(/^\d+(\.\d+)?$/, "must be a positive number")
  .transform(Number)
  .pipe(z.number().positive("must be a positive number"));

/** "a, b,c" -> ["a","b","c"]; the key must exist, the list may be empty. */
export const csvList = z
  .string({ error: "is required" })
  .transform((s) => s.split(",").map((v) => v.trim()).filter(Boolean));

/** One readable line per problem, naming the .env key. */
export function formatEnvIssues(error: z.ZodError): string {
  return error.issues.map((i) => `- ${i.path.join(".")}: ${i.message}`).join("\n");
}
